import { z } from 'zod';

export const SignalGenerationMetadataSchema = z.looseObject({
  generationExecutionId: z.string().min(1).optional(),
});

export type SignalGenerationMetadata = z.infer<
  typeof SignalGenerationMetadataSchema
>;
